import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconWarning, colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const tileContainerCss = "t15sws4q";
const TileContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tileContainerCss, props.className)} />;
});
const tileCardIsErrorCss = "tpux2sn";
const tileCardCss = "tvrwaoy";
export const TileCard = forwardRef((props, ref) => {
  const {
    isError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tileCardCss, {
    [tileCardIsErrorCss]: isError
  }, props.className)} />;
});
const mainBlockCss = "mr2qcwp";
const MainBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mainBlockCss, props.className)} />;
});
const tileCardTitleCss = "t110kozs";
const TileCardTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tileCardTitleCss, props.className)} />;
});
const controlsBlockRightControlsCss = "cef5t8x";
const controlsBlockCss = "c1jgsfwm";
const ControlsBlock = forwardRef((props, ref) => {
  const {
    rightControls,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlsBlockCss, {
    [controlsBlockRightControlsCss]: rightControls
  }, props.className)} />;
});
export const Tile = ({
  componentName,
  icon,
  name,
  description,
  error,
  controls,
  rightControls,
  ...restProps
}) => <TileContainer data-component={componentName}>
    <TileCard {...restProps}>
      <MainBlock>
        {icon}
        <TileCardTitle>{name}</TileCardTitle>
        {description && <BodyText size="medium" color="muted">{description}</BodyText>}
        {!!error && <BodyText size="medium" color={colorTextDestructive}>
            <AlertWarningTriangleIcon color={colorIconWarning} />
            {' '}
            {error}
          </BodyText>}
      </MainBlock>
      <ControlsBlock rightControls={!!rightControls}>
        {rightControls || controls}
      </ControlsBlock>
    </TileCard>
  </TileContainer>;

require("./tile.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tile.js");